import { keyframes } from 'styled-components'

export const bob = keyframes`
    0% {
        transform: translateY(-10px);
    }
    50% {
        transform: translateY(0px);
    }
    100% {
        transform: translateY(-10px);
    }
`

export const heartbeat = keyframes`
    0% {
        transform: scale(1);
    }

    14% {
        transform: scale(1.3);
    }

    28% {
        transform: scale(1);
    }

    42% {
        transform: scale(1.3);
    }

    70% {
        transform: scale(1);
    }
`
